module.exports = __webpack_public_path__ + "img/pix.98d3bfd.png";